export default __webpack_public_path__ + "ui/assets/img/launch-24.svg";